/** Public, non-executable presentation metadata for exactly five quarantined imports.
 * Never include upstream URLs, source paths, prompts, scripts, tokens or raw instructions.
 * Actual state and assignment authority always come from scoped Agentordinary backend.
 */
export type FiveSkillCard = Readonly<{
 publisher:string;license:string;inputs:string;outcome:string;
 connection:string;primaryRecommendation:string;supportRecommendation:string;
}>;
export const fiveQuarantinedSkillCards:Readonly<Record<string,FiveSkillCard>>={
 'Last 30 Days':{
  publisher:'mvanhorn',license:'MIT',
  inputs:'Research topic, requested date window and approved source scope.',
  outcome:'Dated research brief with corroborated sources, genuine citations, contradictions, limitations and unfilled-source gaps.',
  connection:'External sources require separately authorized Retroordinary Connection Hub providers; no paid access enabled.',
  primaryRecommendation:'Research Intelligence specialist',supportRecommendation:'Market Intelligence'
 },
 'anatomy':{
  publisher:'wheresryan22',license:'MIT',
  inputs:'Technical concept, dimensions/values, visual requirements and approved rendering environment.',
  outcome:'Validated accessible isometric SVG/HTML or React explainer artifact, or an explicit blocked rendering state.',
  connection:'Owner-provided inputs can be prepared locally; rendering is disabled until a permitted runtime is verified.',
  primaryRecommendation:'Connie',supportRecommendation:'Brand Identity specialist; Engineering Director when available and authorized'
 },
 'legal-skills-open':{
  publisher:'ThomasMoreAI and credited internal contributors',license:'Apache-2.0; file-specific notices apply',
  inputs:'US or general legal research question, jurisdiction, source dates and provided legal authorities.',
  outcome:'Jurisdiction-scoped legal research or draft, distinguishing verified authority from uncertainty and requiring professional review where consequential.',
  connection:'External legal sources require approved Hub access; legal filing and client contact are not enabled.',
  primaryRecommendation:'Poindexter (Legal & Compliance)',supportRecommendation:'Check'
 },
 'SOTA-skills':{
  publisher:'Martin Holovsky',license:'CC-BY-4.0 for content; Apache-2.0 for designated code',
  inputs:'Bounded engineering objective or audit scope, approved code and evidence, BUILD/AUDIT selection.',
  outcome:'Evidence-grounded BUILD guidance or an AUDIT with verifiable file/line findings and explicit limitations.',
  connection:'Local read-only guidance is preparable; external tools require separate approval.',
  primaryRecommendation:'Eli (currently paused)',supportRecommendation:'Check'
 },
 'snowshoe':{
  publisher:'Igor Kravcenko',license:'Apache-2.0; NOTICE preserved',
  inputs:'Approved repository scope, changed-file evidence and permitted structured CLI results.',
  outcome:'Repository understanding and staleness report from inspected evidence; never a fabricated completed scan.',
  connection:'Headless CLI access requires authorized filesystem scope; no map UI or global installer is permitted.',
  primaryRecommendation:'Eli (currently paused)',supportRecommendation:'Flow (currently paused)'
 }
};
